import { render, staticRenderFns } from "./ProductSpecificationSection.vue?vue&type=template&id=c99e6050&"
import script from "./ProductSpecificationSection.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports